import { Directive, TemplateRef } from '@angular/core';

@Directive({
	// tslint:disable-next-line: directive-selector
	selector: 'ng-template[fnPanelContent]',
})
export class FnAccordianPanelContentDirective {
	constructor(public templateRef: TemplateRef<void>) {}
}
